import { render } from "./UserFormPage.vue?vue&type=template&id=2cf0da6e&ts=true"
import script from "./UserFormPage.vue?vue&type=script&lang=ts"
export * from "./UserFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__